import { Monetization } from '@schibsted/account-sdk-browser';

export const isMonetizationInitialized = () => window.schMonetization && window.schMonetization instanceof Monetization;

/**
 * Ensure Monetization is initialized, create default if needed.
 * The SDK auto-registers the instance to window.schMonetization via registerGlobal.
 * This is needed for Consent or Pay to work, as Sourcepoint and TCF rely on this global instance to check if user has an AdChoices subscription.
 * @returns {Monetization}
 */
export const ensureMonetization = (config) => {
    if (isMonetizationInitialized()) {
        return window.schMonetization;
    }

    const defaultConfig = {
        clientId: CONFIG.spid.clientId,
        sessionDomain: CONFIG.spid.sessionDomain,
    };

    return new Monetization(config || defaultConfig);
};
